import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex);

const store = new Vuex.Store({
    state: {
        redirect: {},
        userInfo: {},
        companyInfo: {},
    },

    mutations: {
        setUserInfo(state, userInfo){
            state.userInfo = userInfo;
        },

        setCompanyInfo(state, companyInfo){
            state.companyInfo = companyInfo;
        },

        setRedirect(state, redirect) {
            state.redirect = redirect;
        }
    }
});

export default store;


// WEBPACK FOOTER //
// ./src/store/index.js